//epi
import batiment_1 from "assets/progressMap/iserba/houses/batiment_1.svg";
import batiment_2 from "assets/progressMap/iserba/houses/batiment_2.svg";
import batiment_3 from "assets/progressMap/iserba/houses/batiment_3.svg";
import batiment_4 from "assets/progressMap/iserba/houses/batiment_4.svg";
import batiment_5 from "assets/progressMap/iserba/houses/batiment_5.svg";

import confogaz from "assets/progressMap/iserba/flags/confogaz.svg";
import elonova from "assets/progressMap/iserba/flags/elonova.svg";
import eopur from "assets/progressMap/iserba/flags/eopur.svg";
import filacom from "assets/progressMap/iserba/flags/filacom.svg";
import info_tec_services from "assets/progressMap/iserba/flags/info_tec_services.svg";
import iserba from "assets/progressMap/iserba/flags/iserba.svg";
import reso_confort from "assets/progressMap/iserba/flags/reso_confort.svg";
import sanilogis from "assets/progressMap/iserba/flags/sanilogis.svg";
import sevanova from "assets/progressMap/iserba/flags/sevanova.svg";
import smecso from "assets/progressMap/iserba/flags/smecso.svg";
import tekinova from "assets/progressMap/iserba/flags/tekinova.svg";
import unica from "assets/progressMap/iserba/flags/unica.svg";
import vizavy from "assets/progressMap/iserba/flags/vizavy.svg";

import arbre_1 from "assets/progressMap/arbre_1.svg";
import arbre_2 from "assets/progressMap/arbre_2.svg";
import buisson from "assets/progressMap/buisson.svg";

export const iconMap = {
  //HOUSES
  batiment_1: batiment_1,
  batiment_2: batiment_2,
  batiment_3: batiment_3,
  batiment_4: batiment_4,
  batiment_5: batiment_5,

  //FLAGS
  confogaz: confogaz,
  elonova: elonova,
  eopur: eopur,
  filacom: filacom,
  info_tec_services: info_tec_services,
  iserba: iserba,
  reso_confort: reso_confort,
  sanilogis: sanilogis,
  sevanova: sevanova,
  smecso: smecso,
  tekinova: tekinova,
  unica: unica,
  vizavy: vizavy,

  //NATURE
  arbre_1: arbre_1,
  arbre_2: arbre_2,
  buisson: buisson,
};
